export const countries = () => 'FNOLSifarnici/GetDrzave';
export const cities = () => 'FNOLSifarnici/GetNaselja';
export const policyDetails = () => 'FNOLAutoOdgovornost/GetDetaljiPolise';
export const vehicleTypes = () => 'FNOLSifarnici/GetAutoodgovornostVrstaVozila';
export const leasingEntities = () => 'FNOLSifarnici/GetLizingKuce';
export const personRoles = () => 'FNOLSifarnici/GetAutoodgovornostSvojstvoUcesnika';
export const personRelations = () => 'FNOLSifarnici/GetAutoodgovornostSvojstvoLica';
export const industrialClassifications = () => 'FNOLSifarnici/GetAutoodgovornostSifarnikDelatnosti';
export const claimConfirmation = () => 'FNOL/PotvrdaPrijaveSteteLista';
export const claimConfirmationAnonymous = () => 'FNOL/PotvrdaPrijaveSteteListaAnonimni';
export const oneTimePassword = () => 'FNOL/GenerisiPrivremenuLozinku';
export const documents = (id: string) => `FNOL/GetDokumentaZaUpload?stetaTempId=${id}`;
export const claimSubmit = () => 'FNOLAutoOdgovornost/OnlinePrijavaStete';
export const addDocuments = () => 'FNOL/UploadDokumentacije';
